import { render, staticRenderFns } from "./SiteSettings.component.html?vue&type=template&id=6baa4cf8&scoped=true&external"
import script from "./SiteSettings.component.ts?vue&type=script&lang=ts&external"
export * from "./SiteSettings.component.ts?vue&type=script&lang=ts&external"
import style0 from "./SiteSettings.component.scss?vue&type=style&index=0&id=6baa4cf8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa4cf8",
  null
  
)

export default component.exports